export default __webpack_public_path__ + "80846fcb11c2414d3289001eb8ad8ae0.jpg";